module.exports = __webpack_public_path__ + "img/3.ada16363.jpg";